import './TrustedContactsTableActionModal.scss';

import { bool, object } from 'prop-types';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';

import ClickOffSensor from 'components/shared/ClickOffSensor/ClickOffSensor';
import EditTrustedContacts from 'components/layouts/Preferences/TrustedContacts/TrustedContactsModal/TrustedContactsModal';
import TrustedContactsDeleteModal from './TrustedContactsDeleteModal';

class TrustedContactsTableActionModal extends React.Component {
  state = {
    show: false,
    showConfirmation: false,
    updatingContacts: false
  };

  componentDidUpdate(prevProps) {
    const { requestStatus } = this.props;
    if (
      prevProps.requestStatus['updateCustomerPreferences'] !==
        requestStatus['updateCustomerPreferences'] &&
      ['RECEIVED', 'ERROR'].includes(requestStatus['updateCustomerPreferences'])
    ) {
      this.setState({
        show: false,
        showConfirmation: false,
        showEdit: false,
        updatingContacts: false
      });
    }
  }

  close = () => {
    this.setState({ show: false });
  };

  closeDeleteConfirmation = () => {
    this.setState({
      show: false,
      showConfirmation: false
    });
  };

  open = () => {
    this.setState({ show: true });
  };

  showDeleteConfirmation = () => {
    this.setState({ showConfirmation: true });
  };

  showEditModal = () => {
    this.setState({ showEdit: true });
  };

  closeEditModal = () => {
    this.setState({ showEdit: false });
  };

  render() {
    const { account, contact, isMobileLayout } = this.props;
    const { show, showConfirmation, showEdit } = this.state;

    const buttonClass = classnames('trusted-contacts-table-action-button', {
      open: show
    });

    const actionClass = classnames(
      'chevron',
      { 'aa-chevron-up': show },
      { 'aa-chevron-down': !show }
    );

    if (isMobileLayout) {
      return (
        <Fragment>
          {showEdit && (
            <EditTrustedContacts
              account={account}
              closeToolTip={this.closeEditModal}
              contact={contact}
              openModal={showEdit}
              modalTitle="Edit Trusted Contacts"
            />
          )}
          <a onClick={this.showEditModal}>Edit</a>
        </Fragment>
      );
    }

    return (
      <ClickOffSensor
        className="trusted-contacts-table-action"
        isOpen={show}
        onClickOut={this.close}>
        <button className={buttonClass} onClick={show ? this.close : this.open}>
          Actions <span className={actionClass} />
        </button>
        {showEdit && (
          <EditTrustedContacts
            account={account}
            closeToolTip={this.closeEditModal}
            contact={contact}
            openModal={showEdit}
            modalTitle="Edit Trusted Contacts"
          />
        )}
        {showConfirmation && (
          <TrustedContactsDeleteModal
            account={account}
            contact={contact}
            onClose={this.closeDeleteConfirmation}
          />
        )}
        {show && (
          <div className="trusted-contacts-table-action-links-container">
            <ul className="trusted-contacts-table-action-drop-down-content">
              <li className="trusted-contacts-table-action-item">
                <a onClick={this.showEditModal}>Edit</a>
              </li>
              <li className="trusted-contacts-table-action-item">
                <a onClick={this.showDeleteConfirmation}>Delete</a>
              </li>
            </ul>
          </div>
        )}
      </ClickOffSensor>
    );
  }
}

TrustedContactsTableActionModal.propTypes = {
  account: object.isRequired,
  contact: object.isRequired,
  isMobileLayout: bool.isRequired,
  requestStatus: object.isRequired
};

const mapStateToProps = (state) => ({
  isMobileLayout: state.view.isMobileLayout,
  requestStatus: state.requestStatus
});

export default connect(mapStateToProps)(TrustedContactsTableActionModal);
